import $ from 'jquery';

var hash;
export default class Bonus {
  constructor(app) {
    this.app = app;
    // console.log('Bonus');
    // console.log(this.app.host);
    this.getData();
    this.hashchange();
  }
  getData(){
    var prod_arr;
    var prod_xhr = new XMLHttpRequest();
    prod_xhr.open('get', this.app.host + '/api/products', true);
    prod_xhr.send();
    prod_xhr.onload = function() {
      if (prod_xhr.status == 200) {
        prod_arr = JSON.parse(prod_xhr.responseText);
        // console.log(prod_arr);
        for(var x in prod_arr.data){
          // console.log(x);
          for(var i=0;i<prod_arr.data[x].length;i++){
            if(prod_arr.data[x][i].is_special==true){
                $('.prod').append(''+
                '<a class="prod__item" href="#sub3'+'?id='+prod_arr.data[x][i].id+'">'+
                  '<div class="prod__img">'+
                    '<img src="'+this.app.host+prod_arr.data[x][i].medias[0].path+'" />'+
                  '</div>'+
                  '<h4 class="prod__title">'+prod_arr.data[x][i].title+'</h4>'+
                '</a>')
            }
          }
        }
      }
    }.bind(this)
  }
  getDetail(pid){

    var detail_arr;
    var detail_xhr = new XMLHttpRequest();
    detail_xhr.open('get', this.app.host + '/api/products/'+pid, true);
    detail_xhr.send();
    detail_xhr.onload = function() {
      if (detail_xhr.status == 200) {
        detail_arr = JSON.parse(detail_xhr.responseText);
        $('.detail .detail__img img').attr('src', this.app.host+detail_arr.data[0].medias[0].path);
        $('.detail .detail__text .title').html(''+detail_arr.data[0].title);
        $('.detail .detail__text .subtitle').html(''+detail_arr.data[0].content_desc);
        $('.detail').show();
        $('.prod').hide();
      }
    }.bind(this)
  }
  refreshSlder(){

  }
  hashchange() {

    hash = this.app.hash;
    this.hashId = hash.replace("sub","");
    console.log(this.app.prodId);
    if(this.app.prodId==""){
      $('.detail').hide();
      $('.prod').show();
    }else{
      this.getDetail(this.app.prodId);
    }
  }
}
